import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M 10.113296,9.2535868 C 9.2574982,9.2537038 8.7227069,10.180155 9.1506206,10.921288 l 1.8855324,3.267478 c 0.427475,0.74353 1.50022,0.74353 1.927694,0 l 1.885532,-3.267478 C 15.277293,10.180155 14.742503,9.2537038 13.886705,9.2535868 Z" />,
  'SortingDown'
);
